import React from "react";
import Scene from "../layout/about/Scene";

const Index = () => <Scene au />;

export default Index;
